/* eslint-disable complexity */
import React, {Component} from 'react';

import {
	TEST_STEPS,
	TEST_STEPS_BY_ID,
	YOUTH_TEST_STEPS_BY_ID,
	CHILD_SCRNG_TEST_STEPS_BY_ID,
	CHILD_TEST_STEPS_BY_ID,
	Z_SCORE_OFFSET,
	Z_SCORE_MAX,
	CHILD_TEST_NORMING_STEPS_BY_ID,
	TEST_NORMING_STEPS_BY_ID,
	YOUTH_TEST_NORMING_STEPS_BY_ID,
	CHILD_SCRNG_TEST_NORMING_STEPS_BY_ID,
} from '../../../constants';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

import roundWithDecimals from 'utils/roundWithDecimals';

import normalDistributionImage from 'assets/kurve.png';
import strings from 'utils/strings';
import InformationPane from 'components/InformationPane';
import {getTimeTakenInSeconds} from '../Utils/getTimeTakenInSecondsForLeseproven';

class SubtestNormingReport extends Component {
	constructor(props) {
		super(props);

		this.state = {
			renderPaneAlert: false,
			paneMessage: strings.confirmDeleteSubtestPermanently,
		};
	}

	// eslint-disable-next-line complexity
	returnTestScores = (
		id,
		totalCorrect,
		testType,
		flag,
		zScore,
		tScore,
		scaledScore,
		standardScore
	) => {
		if (flag === 'zscore') {
			switch (id) {
				case 0:
					if (totalCorrect < 5 && testType === 'youth-followup')
						return `: < ` + roundWithDecimals(zScore, 2);
					else if (
						totalCorrect > 17 &&
						testType === 'youth-followup'
					) {
						return `: > ` + roundWithDecimals(zScore, 2);
					} else if (
						totalCorrect < 17 &&
						totalCorrect > 5 &&
						testType === 'youth-followup'
					) {
						return `: ` + roundWithDecimals(zScore, 2);
					}
					return `: ` + roundWithDecimals(zScore, 2);
				case 1:
					return `: ` + roundWithDecimals(zScore, 2);
				case 2:
					return `: ` + roundWithDecimals(zScore, 2);
				case 3:
					return `: ` + roundWithDecimals(zScore, 2);
				case 4:
					if (totalCorrect < 62 && testType === 'youth-followup') {
						return `: < ` + roundWithDecimals(zScore, 2);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect > 115
					) {
						return `: > ` + roundWithDecimals(zScore, 2);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect < 115 &&
						totalCorrect > 62
					) {
						return `: ` + roundWithDecimals(zScore, 2);
					}
					return `: ` + roundWithDecimals(zScore, 2);
				case 5:
					return `: ` + roundWithDecimals(zScore, 2);
				case 6:
					return `: ` + roundWithDecimals(zScore, 2);
				case 7:
					return `: ` + roundWithDecimals(zScore, 2);
				case 8:
					return `: ` + roundWithDecimals(zScore, 2);
				case 9:
					return `: ` + roundWithDecimals(zScore, 2);
				case 10:
					return `: ` + roundWithDecimals(zScore, 2);
				case 13:
					return `: ` + roundWithDecimals(zScore, 2);
			}
		}
		if (flag === 'tscore') {
			switch (id) {
				case 0:
					if (totalCorrect < 5 && testType === 'youth-followup') {
						return `: < ` + roundWithDecimals(tScore, 0);
					} else if (
						totalCorrect > 17 &&
						testType === 'youth-followup'
					) {
						return `: > ` + roundWithDecimals(tScore, 0);
					} else if (
						totalCorrect < 17 &&
						totalCorrect > 5 &&
						testType === 'youth-followup'
					) {
						return `: ` + roundWithDecimals(tScore, 0);
					}
					return `: ` + roundWithDecimals(tScore, 0);
				case 1:
					return `: ` + roundWithDecimals(tScore, 0);
				case 2:
					return `: ` + roundWithDecimals(tScore, 0);
				case 3:
					return `: ` + roundWithDecimals(tScore, 0);
				case 4:
					if (totalCorrect < 62 && testType === 'youth-followup') {
						return `: < ` + roundWithDecimals(tScore, 0);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect > 115
					) {
						return `: > ` + roundWithDecimals(tScore, 0);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect < 115 &&
						totalCorrect > 62
					) {
						return `: ` + roundWithDecimals(tScore, 0);
					}
					return `: ` + roundWithDecimals(tScore, 0);
				case 5:
					return `: ` + roundWithDecimals(tScore, 0);
				case 6:
					return `: ` + roundWithDecimals(tScore, 0);
				case 7:
					return `: ` + roundWithDecimals(tScore, 0);
				case 8:
					return `: ` + roundWithDecimals(tScore, 0);
				case 9:
					return `: ` + roundWithDecimals(tScore, 0);
				case 10:
					return `: ` + roundWithDecimals(tScore, 2);
				case 13:
					return `: ` + roundWithDecimals(tScore, 2);
			}
		}
		if (flag === 'scaledscore') {
			switch (id) {
				case 0:
					if (totalCorrect < 5 && testType === 'youth-followup') {
						return `: < ` + roundWithDecimals(scaledScore, 0);
					} else if (
						totalCorrect > 17 &&
						testType === 'youth-followup'
					) {
						return `: > ` + roundWithDecimals(scaledScore, 0);
					} else if (
						totalCorrect < 17 &&
						totalCorrect > 5 &&
						testType === 'youth-followup'
					) {
						return `: ` + roundWithDecimals(scaledScore, 0);
					}
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 1:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 2:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 3:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 4:
					if (totalCorrect < 62 && testType === 'youth-followup') {
						return `: < ` + roundWithDecimals(scaledScore, 0);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect > 115
					) {
						return `: > ` + roundWithDecimals(scaledScore, 0);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect < 115 &&
						totalCorrect > 62
					)
						return `: ` + roundWithDecimals(scaledScore, 0);

					return `: ` + roundWithDecimals(scaledScore, 0);

				case 5:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 6:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 7:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 8:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 9:
					return `: ` + roundWithDecimals(scaledScore, 0);
				case 10:
					return `: ` + roundWithDecimals(scaledScore, 2);
				case 13:
					return `: ` + roundWithDecimals(scaledScore, 2);
			}
		}
		if (flag === 'standardScore') {
			switch (id) {
				case 0:
					if (totalCorrect < 5 && testType === 'youth-followup') {
						return `: < ` + roundWithDecimals(standardScore, 0);
					} else if (
						totalCorrect > 17 &&
						testType === 'youth-followup'
					) {
						return `: > ` + roundWithDecimals(standardScore, 0);
					} else if (
						totalCorrect < 17 &&
						totalCorrect > 5 &&
						testType === 'youth-followup'
					) {
						return `: ` + roundWithDecimals(standardScore, 0);
					}
					return `: ` + roundWithDecimals(standardScore, 0);
				case 1:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 2:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 3:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 4:
					if (totalCorrect < 62 && testType === 'youth-followup') {
						return `: < ` + roundWithDecimals(standardScore, 0);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect > 115
					) {
						return `: > ` + roundWithDecimals(standardScore, 0);
					} else if (
						testType === 'youth-followup' &&
						totalCorrect < 115 &&
						totalCorrect > 62
					) {
						return `: ` + roundWithDecimals(standardScore, 0);
					}
					return `: ` + roundWithDecimals(standardScore, 0);

				case 5:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 6:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 7:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 8:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 9:
					return `: ` + roundWithDecimals(standardScore, 0);
				case 10:
					return `: ` + roundWithDecimals(standardScore, 2);
				case 13:
					return `: ` + roundWithDecimals(standardScore, 2);
			}
		}
	};
	formatTime(timeInSeconds) {
		if (timeInSeconds < 60) {
			return strings.formatString(strings.secondsSuffix, timeInSeconds);
		}
		const minutes = Math.floor(timeInSeconds / 60);
		const seconds = timeInSeconds % 60;
		return strings.formatString(
			strings.minutesSecondsLabel,
			minutes,
			seconds
		);
	}

	render() {
		const {
			subtest,
			type,
			testType,
			testResult: {grade = ''} = null,
		} = this.props;

		const {
			totalCorrect,
			id,
			zScore,
			percentile,
			tScore,
			scaledScore,
			standardScore,
			vars,
		} = subtest;

		const zScoreImageLabelWidth = 20.79;
		const zScoreImageRightPaddingWidth = 2.25;
		const zScoreChartWidth =
			100 - zScoreImageRightPaddingWidth - zScoreImageLabelWidth;
		let subtestInfo = null;
		switch (type) {
			case 'child':
				subtestInfo = CHILD_TEST_NORMING_STEPS_BY_ID[id];
				break;
			case 'adult-screening':
				subtestInfo = TEST_NORMING_STEPS_BY_ID[id];
				break;
			case 'youth-screening':
				subtestInfo = YOUTH_TEST_NORMING_STEPS_BY_ID[id];
				break;
			case 'child-screening':
				subtestInfo = CHILD_SCRNG_TEST_NORMING_STEPS_BY_ID[id];
				break;
			case 'child-experimental':
				subtestInfo = CHILD_TEST_NORMING_STEPS_BY_ID[id];
				break;
		}
		let subtestQuestionCount = subtestInfo.questionCount;

		switch (testType) {
			case 'child-followup':
				subtestQuestionCount = subtestInfo.questionCountChild;
				break;
			case 'youth-followup':
				subtestQuestionCount = subtestInfo.questionCountYouthAdult;
				break;
			case 'adult-followup':
				subtestQuestionCount = subtestInfo.questionCountYouthAdult;
				break;
			case 'adult-screening':
				subtestQuestionCount = subtestInfo.questionCount;
				break;
			case 'youth-screening':
				subtestQuestionCount = subtestInfo.questionCount;
				break;
			case 'child-screening' && grade < 5:
				subtestQuestionCount = subtestInfo.questionChild234;
				break;
			case 'child-screening' && grade > 4:
				subtestQuestionCount = subtestInfo.questionChild567;
				break;
			default:
				subtestQuestionCount = subtestInfo.questionCount;
				break;
		}

		const subtestLabel = subtestInfo.label;

		let totalCorrectLabel;

		if (type === 'child' || type === 'child-experimental') {
			let myVars;
			if (vars) {
				myVars = JSON.parse(vars);
			}
			switch (id) {
				case 0: {
					totalCorrectLabel = strings.formatString(
						strings.correctOfPossible,
						totalCorrect,
						subtestQuestionCount
					);
					break;
				}
				case 3: {
					const durationSeconds =
						myVars && myVars.duration ? myVars.duration / 1000 : 0;

					const rapidNamingAnswers = Object.values(
						subtest.answers || {}
					);

					const correctCount = rapidNamingAnswers.filter(
						(answer) => answer && answer.isCorrect === true
					).length;

					const rawScore =
						durationSeconds > 0
							? correctCount / durationSeconds
							: null;

					totalCorrectLabel =
						rawScore !== null
							? roundWithDecimals(rawScore, 2)
							: '–';

					break;
				}
				case 4: {
					totalCorrectLabel = `${totalCorrect}  ${strings.wordreadcorrectly}`;
					break;
				}
				case 5: {
					let achievedPoints = totalCorrect;
					let durationSeconds = 0;

					if (myVars) {
						if (typeof myVars.totalCorrect === 'number') {
							achievedPoints = myVars.totalCorrect;
						}

						if (myVars.duration) {
							durationSeconds = Math.round(
								myVars.duration / 1000
							);
						}
					}

					const rawScore =
						durationSeconds > 0
							? achievedPoints / durationSeconds
							: null;

					const minutes = Math.floor(durationSeconds / 60);
					const seconds = durationSeconds % 60;

					const formattedDuration = `${minutes}:${String(seconds).padStart(2, '0')}`;

					totalCorrectLabel = (
						<>
							{achievedPoints} av {subtestQuestionCount} mulige
							poeng.
							<br />
							Total tid brukt på alle oppgavene:{' '}
							{formattedDuration}.
							<br />
							Råskår:{' '}
							{rawScore !== null
								? roundWithDecimals(rawScore, 2)
								: '–'}
						</>
					);

					break;
				}
				case 10:
				case 13: {
					const possibleWord =
						subtest.language === 'nn' ? 'moglege' : 'mulige';

					totalCorrectLabel = `${totalCorrect} av ${subtestQuestionCount} ${possibleWord}`;

					break;
				}
				default: {
					totalCorrectLabel = strings.formatString(
						strings.scoreOfTotal,
						totalCorrect,
						subtestQuestionCount
					);
				}
			}
		} else if (type !== 'child' && type !== 'child-experimental') {
			if (subtestInfo.name === TEST_STEPS.SKRIVEHASTIGHET) {
				totalCorrectLabel = `${totalCorrect} ${strings.wordsperminute}`;
			} else {
				totalCorrectLabel = `${totalCorrect} av ${subtestQuestionCount}`;
			}
		}
		let updatedZScore;
		if (zScore < -4) {
			updatedZScore = -4;
		} else if (zScore > 4) {
			updatedZScore = 4;
		} else {
			updatedZScore = zScore;
		}
		const testZScorePercentage =
			(updatedZScore + Z_SCORE_OFFSET) / Z_SCORE_MAX;
		const testZChartBarLeft =
			zScoreImageLabelWidth + testZScorePercentage * zScoreChartWidth;

		let leseprovenTimeTakenInSeconds = null;

		if (this.props.subtest.id === 5) {
			leseprovenTimeTakenInSeconds = getTimeTakenInSeconds(
				this.props.subtest.answers
			);
		}
		return (
			<div className="sub-test" key={id}>
				<h3 className="sub-test__name">{subtestLabel}</h3>
				<div className="sub-test__scores">
					<div className="sub-test__col">
						<div className="lit-z-chart">
							{[
								'youth-followup',
								'adult-followup',
								'child-followup',
							].includes(testType) && (
								<img
									className="lit-z-chart__figure"
									src={normalDistributionImage}
									alt="Graph with normal distribution chart"
								/>
							)}
							<div
								className="lit-z-chart-bar"
								style={{
									left: `${testZChartBarLeft}%`,
								}}
							>
								{[
									'youth-followup',
									'adult-followup',
									'child-followup',
								].includes(testType) && (
									<div
										className={classNames({
											'lit-z-chart-bar__fill': true,
											positive: zScore > 1,
											negative: zScore < -1,
										})}
									/>
								)}
							</div>
						</div>
					</div>
					{this.state.renderPaneAlert && (
						<InformationPane
							paneMessage={this.state.paneMessage}
							onApproval={() => {
								this.setState({
									renderPaneAlert: false,
								});
								this.props.resetSubtest(
									this.props.testId,
									this.props.subtest.id
								);
							}}
							onCloseWindow={() => {
								this.setState({
									renderPaneAlert: false,
								});
							}}
							onDisproval={() => {
								this.setState({
									renderPaneAlert: false,
								});
							}}
							category={'confirmation'}
						/>
					)}
					<div className="sub-test__col">
						{this.props.isSuperAdmin && (
							<div style={{float: 'right'}}>
								<button
									className="lit-mytests-header-mytest-icon-btn-ternary"
									title={strings.deleteSubtest}
									onClick={() => {
										this.setState({
											renderPaneAlert: true,
										});
									}}
								>
									<FontAwesomeIcon
										size="lg"
										className="lit-mytests-header-mytest-icon-btn-icon"
										icon={faTrash}
									/>
								</button>
							</div>
						)}

						<h4 className="sub-test__heading">
							{strings.overview}
						</h4>
						<div className="sub-test-horizontal-chart">
							<p className="sub-test__value">
								{id === 5 ? (
									totalCorrectLabel
								) : (
									<>
										<strong>{strings.rawscore}</strong>
										{`: `}
										{totalCorrectLabel}
									</>
								)}
							</p>
							{[
								'youth-followup',
								'adult-followup',
								'child-followup',
							].includes(testType) && (
								<>
									<p className="sub-test__value">
										<strong>{strings.zscore}</strong>

										{this.returnTestScores(
											id,
											totalCorrect,
											this.props.testType,
											'zscore',
											zScore,
											tScore,
											scaledScore,
											standardScore
										)}
									</p>

									<p className="sub-test__value">
										<strong>{strings.tscore}</strong>
										{this.returnTestScores(
											id,
											totalCorrect,
											this.props.testType,
											'tscore',
											zScore,
											tScore,
											scaledScore,
											standardScore
										)}
									</p>
									<p className="sub-test__value">
										<strong>
											{strings.standardScoreLabelNo}
										</strong>
										{this.returnTestScores(
											id,
											totalCorrect,
											this.props.testType,
											'standardScore',
											zScore,
											tScore,
											scaledScore,
											standardScore
										)}
									</p>
									<p className="sub-test__value">
										<strong>{strings.scaledscore}</strong>
										{this.returnTestScores(
											id,
											totalCorrect,
											this.props.testType,
											'scaledscore',
											zScore,
											tScore,
											scaledScore,
											standardScore
										)}
									</p>
									<p className="sub-test__value">
										<strong>
											{strings.percentilescore}
										</strong>
										{`: `}
										{roundWithDecimals(percentile, 0)}
									</p>

									{subtest.id === 5 &&
										leseprovenTimeTakenInSeconds && (
											<p className="sub-test__value">
												<strong>
													{strings.timeused}
												</strong>
												:{' '}
												{this.formatTime(
													this.props.subtest.answers.at(
														-1
													).value
												)}
											</p>
										)}

									<p className="sub-test__value rating">
										{strings.assessment}
										{zScore <= -1 && (
											<span className="sub-test__assessmentText">
												{strings.formatString(
													strings.assessmentsubtestbelow,
													roundWithDecimals(
														zScore,
														2
													),
													<span className="sub-test__nobBreakText">
														<em>{strings.under}</em>
													</span>
												)}
												<br></br>
												<span className="sub-test__nobBreakText">
													{strings.theAverage}
												</span>
											</span>
										)}
										{zScore >= 1 && (
											<span className="sub-test__assessmentText">
												{strings.formatString(
													strings.assessmentsubtestbelow,
													roundWithDecimals(
														zScore,
														2
													),

													<em>{strings.over}</em>
												)}
												<br></br>
												<span className="sub-test__nobBreakText">
													{strings.theAverage}
												</span>
											</span>
										)}
										{zScore < 1 && zScore > -1 && (
											<span className="sub-test__assessmentText">
												{
													strings.assessmentsubtestnormal
												}
											</span>
										)}
									</p>
								</>
							)}
						</div>
					</div>
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default SubtestNormingReport;
